<div class="app" *ngIf="checkLogIn()">
    <app-navigation></app-navigation>
    <div class="app-container">
        <!-- Sidebar -->
        <app-side-nav ></app-side-nav>
        <!-- Content Area -->
        <div class="content-area" [class.expanded]="isExpanded">
            <router-outlet></router-outlet>
        </div>
    </div>
    <app-chatbot></app-chatbot>
</div>

<div>
    <app-login-register *ngIf="!checkLogIn()"></app-login-register>
</div>

<div class="app-version">v {{version}}</div>